import { useLocation, useNavigate } from 'react-router-dom';
import { LayoutDashboard, RefreshCw, ScrollText, Users } from 'lucide-react';

const items = [
  { label: 'Accueil', path: '/', icon: LayoutDashboard },
  { label: 'Utilis.', path: '/utilisateurs', icon: Users },
  { label: 'Sync', path: '/syncs', icon: RefreshCw },
  { label: 'Logs', path: '/logs', icon: ScrollText },
];

export default function MobileBottomNav() {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="flex items-center justify-around bg-white border-t border-slate-200 py-2 w-full">
      {items.map((item) => {
        const active =
          item.path === '/'
            ? location.pathname === '/'
            : location.pathname === item.path || location.pathname.startsWith(`${item.path}/`);
        const Icon = item.icon;
        return (
          <button
            key={item.path}
            type="button"
            onClick={() => navigate(item.path)}
            className="flex flex-col items-center gap-0.5 px-2 py-1"
          >
            <Icon size={20} className={active ? 'text-orange-500' : 'text-slate-400'} />
            <span className={`text-[10px] font-medium ${active ? 'text-orange-500' : 'text-slate-400'}`}>
              {item.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
